import React, { useEffect, useState } from "react";
import axios from "axios";
import { useEntitlement } from "../../contexts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const HeaderCard = ({
  setFilters,
  onPendingCount,
  onActivatePending,
  isPendingActive = false,
}) => {
  const [count, setCount] = useState(0);
  // KYC ID verification (Feature 29): no feature, no pending-verification
  // banner — and no request for the count either.
  const hasKyc = useEntitlement("kyc_verification");

  const getPendingIdVerificationMembers = async () => {
    try {
      const { data } = await axios.post(`/api/users/count`);
      setCount(data);
      if (onPendingCount) onPendingCount(data);
    } catch {
      /* silent */
    }
  };

  const onSetFilter = () => {
    if (onActivatePending) {
      onActivatePending();
      return;
    }
    setFilters((prev) => ({
      ...prev,
      pending_id_verification: !prev.pending_id_verification,
    }));
  };

  useEffect(() => {
    if (!hasKyc) return;
    getPendingIdVerificationMembers();
  }, [hasKyc]);

  if (!hasKyc || !count) return null;

  return (
    // Same shape as the Listings price-review banner (`.prb-card`): supporting line over a
    // headline in the copy column, pill action pinned to its bottom, glyph in the media slot.
    // The geometry both cards use lives in styles/_alert-card.scss.
    // The row wrapper holds the card to ONE column of the Listings 3-up grid. Without it the
    // card stretched the full content width and stopped reading as the same component.
    <div className="users-alert-row">
      <button
        type="button"
        className={`users-alert-card${isPendingActive ? " users-alert-card--active" : ""}`}
        onClick={onSetFilter}
      >
        <span className="users-alert-card__content">
          <span className="users-alert-card__copy">
            <span className="users-alert-card__label">
              {count} member{count === 1 ? "" : "s"} need review
            </span>
            <span className="users-alert-card__title">ID Verification Pending</span>
          </span>
          <span className="users-alert-card__action">
            {isPendingActive ? "Close" : "View"}
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
        </span>

        <span className="users-alert-card__media" aria-hidden="true">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="users-alert-card__glyph"
          />
        </span>
      </button>
    </div>
  );
};

export default HeaderCard;
